import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ChickletPrimaryDisplayLabel } from '../../../extensions/constants/BehaviorTypes';
import { useAssociatedObjectsCardRedesignContext } from '../../../context/AssociatedObjectsCardRedesignContext';
import { useBehavior } from '../../../extensions/hooks/useBehavior';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationChicletTitle({
  association
}) {
  const {
    hasScope,
    isUngated,
    objectTypeDefinition,
    propertyDefinitions
  } = useAssociatedObjectsCardRedesignContext();
  const PrimaryDisplayComponent = useBehavior(ChickletPrimaryDisplayLabel, association.objectTypeId, hasScope, isUngated);
  const primaryDisplayPropertyName = objectTypeDefinition === null || objectTypeDefinition === void 0 ? void 0 : objectTypeDefinition.primaryDisplayLabelPropertyName;
  const primaryDisplayProperty = propertyDefinitions === null || propertyDefinitions === void 0 ? void 0 : propertyDefinitions.find(property => property.property.name === primaryDisplayPropertyName);
  const primaryDisplayPropertyValue = getPropertyValueFromProperties(association.properties, primaryDisplayPropertyName || '');
  return /*#__PURE__*/_jsx(TruncateString, {
    useFlex: true,
    fixedChildren: association.labels.primaryLabel && /*#__PURE__*/_jsx(Tag, {
      flexShrink: 0,
      marginInlineStart: "200",
      children: association.labels.primaryLabel
    }),
    children: primaryDisplayProperty && primaryDisplayPropertyName ? /*#__PURE__*/_jsx(PrimaryDisplayComponent, {
      isAiAssociation: Boolean('isAiAssociation' in association && association.isAiAssociation),
      properties: association.properties,
      canView: true,
      primaryDisplayProperty: {
        name: primaryDisplayPropertyName,
        definition: primaryDisplayProperty === null || primaryDisplayProperty === void 0 ? void 0 : primaryDisplayProperty.property,
        value: primaryDisplayPropertyValue !== null && primaryDisplayPropertyValue !== void 0 ? primaryDisplayPropertyValue : null
      },
      toObjectId: association.objectId,
      toObjectTypeId: association.objectTypeId
    }) : DISPLAY_LABEL_FALLBACK
  });
}
export default AssociationChicletTitle;